import { constants } from "../constants";

export const DEFAULT_STATE = {
  adyenResp: {}
};

const var1 = (state = DEFAULT_STATE, { type, payload } = {}) => {
  switch (type) {
    case constants.SET_ADYEN_RESP:
      return { ...state, adyenResp: payload.adyenResp };
    case constants.CLEAR_ADYEN_RESP:
      return DEFAULT_STATE;
    default:
      return state;
  }
};

export default var1;
